import * as Sentry from "@sentry/gatsby";

Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});